import { createCn } from "cn/config"

// Tixbase type sizes (@theme in globals.css) registered as font sizes, so cn
// does not mistake `text-body-xs` for a text color and drop it next to
// `text-foreground`. Keep in sync with the --text-* entries in globals.css.
export const cn = createCn({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "display",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "sub1",
            "sub2",
            "sub3",
            "sub4",
            "sub5",
            "body-lg",
            "body",
            "body4",
            "body-sm",
            "body-xs",
            "label",
            "label-lg",
            "tablet-h1",
            "tablet-h2",
            "tablet-h3",
            "tablet-h4",
            "tablet-h5",
            "tablet-h6",
            "tablet-body1",
            "tablet-body1-md",
            "tablet-body2",
            "tablet-body2-md",
            "tablet-body2-sb",
            "tablet-btn-lg",
            "tablet-btn-md",
            "tablet-btn-sm",
            "tablet-label-lg",
            "tablet-label-md",
            "mobile-h1",
            "mobile-h2",
            "mobile-h3",
            "mobile-h4",
            "h3-mobile",
            "mobile-sub1",
            "mobile-sub2",
            "mobile-body1",
            "mobile-body1-md",
            "mobile-body2",
            "mobile-body3",
            "mobile-btn-lg",
            "mobile-btn-md",
            "mobile-btn-sm",
          ],
        },
      ],
    },
  },
})
